import React from 'react'
import { Box, BoxProps } from '@material-ui/core'
import NavigationLink from 'components/shared/NavigationLink'
import useAuth from 'hooks/useAuth'
import { NavigationLinkProps } from '../NavigationLink/NavigationLink'

export interface NavigationLinksProps extends BoxProps {
  items: NavigationLinkProps[]
  onClick?: () => void
}

const NavigationLinks: React.FC<NavigationLinksProps> = ({ items, onClick, ...props }) => {
  const { isAuthenticated } = useAuth()

  return (
    <Box my={1} mx={0.5} {...props}>
      {items.map((item) => (
        <NavigationLink key={item.text} {...(onClick ? { onClick } : {})} {...item} />
      ))}
      {isAuthenticated && <NavigationLink isAnchor to='https://tickets.exec.vip' text='Tickets' target='_blank' />}
    </Box>
  )
}

export default NavigationLinks
